module.exports = __webpack_public_path__ + "img/jilu-icon@2x.291e5908.png";